/**
 * Shown when an asset is locked because an account administrator has
 * configured a mandatory display preference (e.g., a default watermark).
 * Used by the LockIcon default tooltip and any feature surface that reflects
 * the same admin-source lock.
 */
export const ADMIN_LOCK_MESSAGE = 'Your administrator has locked this option';

/**
 * Shown when an asset is locked by the project's lockSpec — the per-project
 * editing allowlist resolved by `@sparemin/embed-config` LockChecker.
 */
export const LOCKSPEC_LOCK_MESSAGE = 'Cannot be changed in this project';

/**
 * Shown when an asset is locked by a template's lockSpec while editing the
 * template itself (wizard / UCS authoring context, as opposed to a project
 * instantiated from it).  Default reason consumed by
 * `overrideFeaturesFromLockChecker` in lock-features.ts.
 */
export const TEMPLATE_LOCK_MESSAGE = 'Cannot be changed in this template';
